var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66797 5C1.66797 3.61929 2.78726 2.5 4.16797 2.5H15.8346C17.2153 2.5 18.3346 3.61929 18.3346 5V15C18.3346 16.3807 17.2153 17.5 15.8346 17.5H4.16797C2.78726 17.5 1.66797 16.3807 1.66797 15V5ZM4.16797 4.16667C3.70773 4.16667 3.33464 4.53976 3.33464 5V15C3.33464 15.4602 3.70773 15.8333 4.16797 15.8333H15.8346C16.2949 15.8333 16.668 15.4602 16.668 15V5C16.668 4.53976 16.2949 4.16667 15.8346 4.16667H4.16797ZM6.07871 6.91074C6.40415 6.58531 6.93179 6.58531 7.25722 6.91074L9.75723 9.41074C10.0827 9.73618 10.0827 10.2638 9.75723 10.5893L7.25722 13.0893C6.93179 13.4147 6.40415 13.4147 6.07871 13.0893C5.75328 12.7638 5.75328 12.2362 6.07871 11.9107L7.98946 10L6.07871 8.08926C5.75328 7.76382 5.75328 7.23618 6.07871 6.91074ZM10.0013 12.5C10.0013 12.0398 10.3744 11.6667 10.8346 11.6667H13.3346C13.7949 11.6667 14.168 12.0398 14.168 12.5C14.168 12.9602 13.7949 13.3333 13.3346 13.3333H10.8346C10.3744 13.3333 10.0013 12.9602 10.0013 12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.a7c6d6f2e0edb333bd3b5cb4e762f490.svg";
export { ForwardRef as ReactComponent };